import { DataTable } from '@app/components/data-table/data-table';
import { DataTableToolbar } from '@app/components/data-table/data-table-toolbar';
import { useServerDataTable } from '@app/components/data-table/hooks/use-server-data-table';
import { DataTableProps } from '@app/components/data-table/types/data-table';
import { PaginatedGroupProductListList } from '@shared/api/types';
import { useGroupProductsColumns } from './group-products-table-columns';

interface GroupProductsTableProps
  extends DataTableProps<PaginatedGroupProductListList> {
  pageCount: number;
}

export default function GroupProductsTable({
  data,
  status,
  isLoading,
  isFetchedAfterMount,
  isPreviousData,
  pageCount,
}: GroupProductsTableProps) {
  const { table, context } = useServerDataTable({
    data: data?.results ?? [],
    columns: useGroupProductsColumns(),
    pageCount,
    getRowId: (row) => row.uuid,
    initialState: {
      columnVisibility: { uuid: false },
    },
  });

  return (
    <DataTable
      table={table}
      context={context}
      className="bg-gray-00"
      isLoading={(!isFetchedAfterMount && isPreviousData) || isLoading}
      tableLoading={!data && status === 'loading'}
    >
      <DataTableToolbar table={table} />
    </DataTable>
  );
}
